import { render, staticRenderFns } from "./SidebarFilter.vue?vue&type=template&id=03d8b58c"
import script from "./SidebarFilter.vue?vue&type=script&lang=js"
export * from "./SidebarFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports